export const KLARNA = 'klarna'
export const AFTERPAY = 'afterpay'
export const KLARNA_AFTERPAY = 'klarnaafterpay'
export const PAYPAL = 'Paypal'
